import React, { useState } from 'react';
import { API_BASE } from '../../config';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
function LogHydrationModal({ onClose, fetchWithAuth, onSuccess }) {
  useEscapeToClose(onClose);   // Escape dismisses this modal
  const [formData, setFormData] = useState({
    quantity: '',
    unit: 'oz',
    hoursAgo: '0'
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [result, setResult] = useState(null);

  const unitOptions = [
    { value: 'oz', label: 'Ounces (oz)' },
    { value: 'ml', label: 'Milliliters (ml)' },
    { value: 'cups', label: 'Cups' },
    { value: 'liters', label: 'Liters' }
  ];

  const timeOptions = [
    { value: '0', label: 'Just now' },
    { value: '0.5', label: '30 minutes ago' },
    { value: '1', label: '1 hour ago' },
    { value: '1.5', label: '1.5 hours ago' },
    { value: '2', label: '2 hours ago' },
    { value: '3', label: '3 hours ago' }
  ];

  const handleSubmit = async () => {
    if (!formData.quantity || parseFloat(formData.quantity) <= 0) {
      alert('Please enter a valid quantity');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetchWithAuth(
        `${API_BASE}/api/dashboard/log-hydration?quantity=${formData.quantity}&unit=${formData.unit}&hours_ago=${formData.hoursAgo}`,
        { method: 'POST' }
      );

      if (response.ok) {
        const data = await response.json();
        setResult(data);

        // Auto-close after 2 seconds on success
        setTimeout(() => {
          if (onSuccess) onSuccess();
          onClose();
        }, 2000);
      } else {
        const error = await response.json();
        alert(`Error: ${error.detail || 'Failed to log water intake'}`);
      }
    } catch (error) {
      console.error('Error logging hydration:', error);
      alert('Failed to log water intake. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Quick amount buttons
  const quickAmounts = [8, 12, 16, 24, 32];

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal-content wim-modal" >
        <div className="modal-header">
          <h3>💧 Log Water Intake</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {result ? (
            <div className="placeholder-card">
              <div className="text-48 mb-16">✅</div>
              <h4 className="hyd-successTitle">Logged!</h4>
              <p className="text-gray-500">{result.message}</p>
              <div className="hyd-progressCard">
                <div className="hyd-progressValue">
                  {result.percent}%
                </div>
                <div className="hyd-progressLabel">
                  of daily goal
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* Quick Amount Buttons */}
              <div className="mb-5">
                <label className="form-label">Quick Add:</label>
                <div className="hyd-quickButtons">
                  {quickAmounts.map(amount => (
                    <button
                      key={amount}
                      type="button"
                      className="btn btn-secondary btn-sm hyd-quickBtn"
                      onClick={() => setFormData(prev => ({ ...prev, quantity: amount.toString(), unit: 'oz' }))}

                    >
                      {amount} oz
                    </button>
                  ))}
                </div>
              </div>

              {/* Custom Amount */}
              <div className="form-group">
                <label className="form-label">Amount:</label>
                <div className="flex gap-2">
                  <input
                    type="number"
                    className="form-input hyd-amountInput"
                    value={formData.quantity}
                    onChange={(e) => setFormData(prev => ({ ...prev, quantity: e.target.value }))}
                    placeholder="Enter amount"
                    min="0"
                    step="0.5"

                  />
                  <select
                    className="form-select flex-1"
                    value={formData.unit}
                    onChange={(e) => setFormData(prev => ({ ...prev, unit: e.target.value }))}
                  >
                    {unitOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Time */}
              <div className="form-group">
                <label className="form-label">When:</label>
                <select
                  className="form-select"
                  value={formData.hoursAgo}
                  onChange={(e) => setFormData(prev => ({ ...prev, hoursAgo: e.target.value }))}
                >
                  {timeOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
            </>
          )}
        </div>

        {!result && (
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isSubmitting || !formData.quantity}
            >
              {isSubmitting ? 'Logging...' : 'Log Water'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default LogHydrationModal;
